import Vue from "vue";
import BzbsApi from "@/core/Http/BzbsApi.js";
import ConfigManager from "@/config/ConfigManager";
import Locale from "@/helper/locale/locale.js";
export default {
    config: function() {
        return Vue.bzbsConfig;
    },
    appId: function() {
        var params = {
            app_id: ConfigManager.getAppId(),
            locale: Locale.getLocaleCode()
        };
        return params;
    },
    timestamp: function() {
        const timestamp = Date.now();
        return timestamp;
    },
    getTerm() {
        const app_id = this.appId();
        const url = `${ConfigManager.getBlobUrl()}/nestle/pdpaconsent/terms/${ConfigManager.getAppId()}/version.json?v=${this.timestamp()}`;
        return new Promise((resolve, reject) => {
            BzbsApi.GetBzbsGetBlob(url)
                .then(response => {
                    const version = response.data.terms.current_version;
                    const urlBlob = `${ConfigManager.getBlobUrl()}/nestle/pdpaconsent/terms/${
                        app_id.app_id
                    }/${version}/${app_id.locale}?v=${this.timestamp()}`;
                    BzbsApi.GetBzbsGetBlob(urlBlob)
                        .then(res => {
                            resolve(res);
                        })
                        .catch(error => {
                            reject(error);
                        });
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    },
    getPrivacy() {
        const url = `${ConfigManager.getBlobUrl()}/nestle/pdpaconsent/privacy/version.json?v=${this.timestamp()}`;
        return new Promise((resolve, reject) => {
            BzbsApi.GetBzbsGetBlob(url)
                .then(response => {
                    const version = response.data.privacy.current_version;
                    const app_id = this.appId();
                    const urlBlob = `${ConfigManager.getBlobUrl()}/nestle/pdpaconsent/privacy/${version}/${
                        app_id.locale
                    }?v=${this.timestamp()}`;
                    BzbsApi.GetBzbsGetBlob(urlBlob)
                        .then(res => {
                            console.log(res);
                            resolve(res);
                        })
                        .catch(error => {
                            console.log(error);
                            reject(error);
                        });
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    }
};
